import { Text } from '@usealloy/component-library';
import styled, { css } from 'styled-components';

type StyledDropdownComponentTextStyleProps = {
  textColor?: string;
  underlineColor?: string;
  disabled?: boolean;
};
export const StyledDropdownComponentText = styled(Text) <StyledDropdownComponentTextStyleProps>`
  &&& {
    font-family: var(--cl-font-family-mono);
    width: fit-content;
    line-height: var(--cl-line-height-1);
    font-weight: bold;
    ${({ disabled }) => disabled && css`opacity: 0.5;`};
    ${({ textColor }) => css`color: ${textColor ?? 'black'};`}
    ${({ underlineColor }) => underlineColor && css`border-bottom: 2px solid ${underlineColor};`};
  }
`;

